import { Switch } from 'react-router-dom';

import PropTypes from 'prop-types';

import ActionsLogContainer from '../components/CarsonActivity/containers/ActionsLogContainer';
import PersonActionsLogContainer from '../components/CarsonActivity/containers/PersonActionsLogContainer';

import { isAdmin } from '../utils';

import Route from './SentryRoute';

const Routes = ({ match }) => {
  if (!isAdmin()) return null;
  return (
    <Switch>
      <Route path={`${match.path}/`} exact component={ActionsLogContainer} />
      <Route path={`${match.path}/:id`} component={PersonActionsLogContainer} />
    </Switch>
  );
};

Routes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default Routes;
